var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2123_2936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.86044 12.4973C6.26535 12.4973 2.68277 9.97696 0.520717 7.59412C-0.170805 6.82762 -0.170805 5.66953 0.520717 4.90302C2.70776 2.49519 6.35284 -0.0459511 9.99791 -0.000127265C13.6471 -0.0542827 17.2881 2.49102 19.4793 4.89885C20.1708 5.66953 20.1708 6.82345 19.4793 7.58996C17.2881 10.002 13.6347 12.5639 9.98541 12.4931C9.94375 12.4931 9.89793 12.4931 9.85627 12.4931L9.86044 12.4973ZM9.8771 1.24961C6.6736 1.24961 3.42844 3.55747 1.44552 5.74034C1.18724 6.02778 1.18724 6.46519 1.44552 6.7568C3.44927 8.96051 6.75275 11.3017 9.98541 11.2475C13.2472 11.3183 16.5465 8.96467 18.5503 6.7568C18.8086 6.46936 18.8086 6.03195 18.5503 5.74034C16.5674 3.56163 13.3222 1.25378 10.1187 1.25378C10.0812 1.25378 10.0437 1.25378 10.0062 1.25378H9.98541C9.94792 1.25378 9.91043 1.25378 9.87294 1.25378L9.8771 1.24961Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99792 9.99795C8.99813 9.99795 8.05666 9.60636 7.34847 8.89818C6.64029 8.18999 6.25287 7.24852 6.25287 6.24873C6.25287 4.18249 7.93585 2.49951 10.0021 2.49951C11.0019 2.49951 11.9434 2.8911 12.6515 3.59512C13.3597 4.3033 13.7513 5.24477 13.7513 6.24456C13.7513 7.24852 13.3597 8.18999 12.6515 8.89818C11.9434 9.60636 11.0019 9.99378 10.0021 9.99378L9.99792 9.99795ZM9.99792 3.74925C8.61904 3.74925 7.49844 4.86985 7.49844 6.24873C7.49844 6.91526 7.75672 7.54429 8.23162 8.01503C8.70652 8.48576 9.33139 8.74821 9.99792 8.74821C10.6644 8.74821 11.2935 8.48993 11.7642 8.01503C12.235 7.54429 12.4974 6.91526 12.4974 6.24873C12.4974 5.57804 12.2391 4.95317 11.7642 4.47827C11.2893 4.00337 10.6644 3.74509 9.99792 3.74509V3.74925Z",
    fill: "#194142"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2123_2936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 12.4974,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.fa5499d0fa794ab36baac7bc8a1eb70a.svg";
export { ForwardRef as ReactComponent };